/**
 * PageSkeleton - Generic page-level skeleton for Suspense fallbacks
 *
 * Renders a full-page skeleton with navigation placeholder, header, and content area.
 * Use as the fallback for React.lazy() route-level code splitting.
 *
 * @example
 * <Suspense fallback={<PageSkeleton />}>
 *   <LazyPage />
 * </Suspense>
 */
export function PageSkeleton() {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Navigation placeholder */}
      <div className="h-16 bg-white border-b border-slate-300" />

      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="animate-pulse space-y-6">
          {/* Page title */}
          <div className="h-8 bg-slate-200 rounded w-48" />

          {/* Action bar */}
          <div className="flex gap-3">
            <div className="h-10 bg-slate-200 rounded w-32" />
            <div className="h-10 bg-slate-200 rounded w-24" />
          </div>

          {/* Content rows */}
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-14 bg-slate-200 rounded" />
          ))}
        </div>
      </div>
    </div>
  );
}
